import styled, { css } from "styled-components";
import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";
import BodyText from "core/BodyText";
import { medium } from "core/fontStyles";

const badgeColor = colors.accent.lightMode.persian;

export const Container = styled.div`
    width: ${convertPxToRem({ px: 80 })};
    border: 1px solid ${badgeColor};
    ${({ leftMargin }) =>
        leftMargin &&
        css`
            margin-left: ${convertPxToRem({ px: 16 })};
        `}
`;

export const Text = styled(BodyText).attrs({
    size: "sm",
    copyColor: badgeColor,
    alignment: "center",
    type: "p"
})`
    ${medium};
    padding: ${convertPxToRem({ px: 3 })} ${convertPxToRem({ px: 8 })};
`;
